// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-box {
  position: relative;
  display: flex;
  border-radius: 4px;
  padding: 8px;
  align-items: center;
  margin: 0 0 8px;
}
.message-box.success {
  background: #aefffb;
  border: 1px solid var(--success);
  color: #004845;
}
.message-box.success svg {
  fill: var(--success);
}
.message-box.alert {
  background: #fff;
  border: 1px solid var(--warning);
  color: #996e00;
}
.message-box.alert svg {
  fill: var(--warning);
}
.message-box.floating {
  position: absolute;
  width: 240px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1;
  margin: 0;
}
.message-box.info {
  background: #f1f4fa;
  border: 1px solid var(--info);
  color: #2b2b2b;
  margin-top: 16px;
}
.message-box.info svg {
  fill: var(--graph_item_4);
}
.message-box.info .message-box-close {
  top: auto;
  right: 14px;
  padding-top: 2px;
}
.message-box.info .message-box-close svg path {
  fill: var(--color_neutral_800);
}
.message-box .message-box-icon {
  margin: 0 8px 0 0;
  width: 24px;
}
.message-box .message-box-close {
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 0;
}
.message-box .message-box-close svg {
  width: 8px;
  height: 8px;
}
.message-box .message-box-close svg path {
  fill: var(--warning);
}
.message-box svg {
  display: block;
}
.message-box p {
  margin: 4px 0;
  font-size: 12px;
  line-height: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/MessageBox/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AACF;AACE;EAIE,mBAHqB;EAIrB,gCAAA;EACA,cAJoB;AAExB;AAII;EACE,oBAAA;AAFN;AAME;EAIE,gBAHqB;EAIrB,gCAAA;EACA,cAJoB;AAHxB;AASI;EACE,oBAAA;AAPN;AAWE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AATJ;AAYE;EAIE,mBAHkB;EAIlB,6BAAA;EACA,cAJiB;EAKjB,gBAAA;AAbJ;AAeI;EACE,yBAAA;AAbN;AAeI;EACE,SAAA;EACA,WAAA;EACA,gBAAA;AAbN;AAgBQ;EACE,8BAAA;AAdV;AAoBE;EACE,iBAAA;EACA,WAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AAnBJ;AAqBI;EACE,UAAA;EACA,WAAA;AAnBN;AAqBM;EACE,oBAAA;AAnBR;AAwBE;EACE,cAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AAvBJ","sourcesContent":[".message-box {\n  position: relative;\n  display: flex;\n  border-radius: 4px;\n  padding: 8px;\n  align-items: center;\n  margin: 0 0 8px;\n\n  &.success {\n    $lighten_success_50: #aefffb;\n    $darken_success_20: #004845;\n\n    background: $lighten_success_50;\n    border: 1px solid var(--success);\n    color: $darken_success_20;\n\n    svg {\n      fill: var(--success);\n    }\n  }\n\n  &.alert {\n    $lighten_warning_50: #fff;\n    $darken_warning_20: #996e00;\n\n    background: $lighten_warning_50;\n    border: 1px solid var(--warning);\n    color: $darken_warning_20;\n\n    svg {\n      fill: var(--warning);\n    }\n  }\n\n  &.floating {\n    position: absolute;\n    width: 240px;\n    left: 50%;\n    transform: translate(-50%, 0);\n    z-index: 1;\n    margin: 0;\n  }\n\n  &.info {\n    $lighten_info_50: #f1f4fa;\n    $darken_info_20: #2b2b2b;\n\n    background: $lighten_info_50;\n    border: 1px solid var(--info);\n    color: $darken_info_20;\n    margin-top: 16px;\n\n    svg {\n      fill: var(--graph_item_4);\n    }\n    .message-box-close {\n      top: auto;\n      right: 14px;\n      padding-top: 2px;\n\n      svg {\n        path {\n          fill: var(--color_neutral_800);\n        }\n      }\n    }\n  }\n\n  .message-box-icon {\n    margin: 0 8px 0 0;\n    width: 24px;\n  }\n\n  .message-box-close {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    padding: 0;\n\n    svg {\n      width: 8px;\n      height: 8px;\n\n      path {\n        fill: var(--warning);\n      }\n    }\n  }\n\n  svg {\n    display: block;\n  }\n\n  p {\n    margin: 4px 0;\n    font-size: 12px;\n    line-height: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
